export function pxToRem(value, baseNum = 40) {
  if(typeof value==="string"){
    if(/rem$/.test(value)){
      return value;
    }
  }
  var v=parseInt(value, 10) / baseNum;
  if(v){
    return v.toString()+"rem";
  }else{
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/component/common/convert.js